import { $http, buildHeaders } from "./index";

//获取当前登录用户信息
export const home_getuser = () => {
  return $http.get("/admin/Admin/getAuth", {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//修改当前登录用户信息
export const home_setuser = (data) => {
  return $http.post("/admin/Admin/save", data, {
    headers: buildHeaders(3),
  });
};